import type { ChangeEvent } from 'react';

import { omit } from 'pkg/objects';
import withForwardedRef from 'pkg/withForwardedRef';

import MaterialSymbol from 'components/material-symbols';

import * as Input from 'components/form/inputs';
import type { Props as FieldProps } from 'components/form/inputs/field';
import type { MaterialSymbolVariant } from 'components/material-symbols/symbols';

/* @NOTE Currently this component cannot handle external updates */
/* @deprecated */

// Extending FieldProps and TextAreaProps yielded ts error due to incompatible types
// so doing it this way instead
interface ForwardedProps extends FieldProps {
	minRows?: number;
	maxRows?: number;
}

interface Props extends Omit<FieldProps, 'onChange' | 'onTyping'> {
	bounceDelay?: number;
	icon?: MaterialSymbolVariant;
	minRows?: number;
	maxRows?: number;

	onTyping: (value: string) => void;
	onChange: (value: string) => void;
}

export const DelayedTextInput = withForwardedRef((props: Props) => {
	const componentProperties: ForwardedProps = omit(
		props,
		'value',
		'onTyping',
		'onChange',
		'bounceDelay',
		'small',
		'forwardedRef'
	);

	componentProperties.small = props.small;
	componentProperties.forwardedRef = props.forwardedRef;
	componentProperties.changeDelay = props.bounceDelay;

	componentProperties.defaultValue = props.value;

	if (props.onTyping) {
		componentProperties.onTyping = (event: ChangeEvent<HTMLInputElement>) => {
			props.onTyping(event.target.value);
		};
	}

	if (props.onChange) {
		componentProperties.onChange = (event: ChangeEvent<HTMLInputElement>) => {
			props.onChange(event.target.value);
		};
	}

	if (props.minRows || props.maxRows) {
		return <Input.Textarea {...componentProperties} />;
	}

	if (props.icon) {
		return (
			<Input.Field {...componentProperties}>
				<Input.Prefix>
					<MaterialSymbol variant={props.icon} />
				</Input.Prefix>
			</Input.Field>
		);
	}

	return <Input.Field {...componentProperties} />;
});
